import React from "react";

const formatActionTitle = (action) => {
    const _action = action?.replaceAll("-", " ")?.replaceAll("_", " ");
    return _action[0]?.toUpperCase() + _action?.substring(1)?.toLowerCase();
}

const getIcon = (name = '') => {

    switch (name?.toLowerCase()) {
        case "etix":
            return "/assets/icons/etix.svg";

        case "caviar":
            return "/assets/icons/caviar.svg";

        case "postmates":
            return "/assets/icons/postmates.svg";

        case "resy":
            return "/assets/icons/reservation.svg";

        case "doordash":
            return "/assets/icons/doordash.svg";

        case "hotels":
            return "/assets/icons/hotel.svg";

        case "stubhub":
            return "/assets/icons/stubhub.svg";

        case "booking":
            return "/assets/icons/booking.svg";

        case "ticketmaster":
            return "/assets/icons/ticket-master.svg";

        default:
            return "/assets/icons/booking.svg";
    };
}

/**
 * Get all other links apart from the main link
 * @param {*} links
 * @returns
 */
export function getReservationLink(links = []) {
    return links?.filter(r => r.type !== 'Main URL')?.map(link => {
        const { host } = new URL(link?.url);
        const _host = host.replaceAll("www.", "").replaceAll(".com", "");
        const name = _host[0].toUpperCase() + _host?.substring(1)
        const icon = getIcon(name)

        return ({
            url: link?.url,
            type: link?.type,
            name,
            icon: <img src={icon} className='pill_icon' alt="" />,
            action: formatActionTitle(link?.action),
        })
    })
}